// extracted by mini-css-extract-plugin
export var center = "_63-2";
export var clickableRow = "_63-5";
export var expandedRow = "_63-7";
export var hoverable = "_63-4";
export var left = "_63-1";
export var right = "_63-3";
export var row = "_63-0";
export var selectedRow = "_63-6";
export var summaryRow = "_63-8";